/**
 * @desc 列表
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(params: API.bus.systemConfig.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/systemConfig/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
